import { faqList } from "../data";
import HotProduct from "@/components/hot-product.vue";
export default {
  name: "FaqDetail",
  components: {
    HotProduct
  },
  data() {
    return {
      before: {},
      next: {},
      faqInfo: {}
    };
  },
  created() {},
  watch: {
    $route: {
      handler() {
        this.before = {};
        this.next = {};
        this.faqInfo = {};
        const id = this.$route.query.id;
        faqList.forEach((item, index) => {
          if (item.id === id) {
            this.faqInfo = item;
            if (index === 0) {
              this.next = faqList[index + 1];
            } else if (index === faqList.length - 1) {
              this.before = faqList[index - 1];
            } else {
              this.next = faqList[index + 1];
              this.before = faqList[index - 1];
            }
          }
        });
        console.log(this.faqInfo);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    backAction() {
      this.$router.replace("/faq/list");
    },
    clickItem(id) {
      this.$router.replace("/faq/detail?id=" + id);
    }
  }
};
